import tracer from 'dd-trace';
import { StatsD } from 'hot-shots';

tracer.init(); // initialized in a different file to avoid hoisting.

export const metricsClient = new StatsD();
export default tracer;

const INFLIGHT_REQUESTS_METRIC = 'express.requests.inflight';

export function trackInflightRequests(req, res, next) {
  metricsClient.increment(INFLIGHT_REQUESTS_METRIC);
  res.on('finish', () => metricsClient.decrement(INFLIGHT_REQUESTS_METRIC));
  next();
}
